export const ID = 'f22fd27e-8af6-4b2b-9e85-b675493a9d95';

export const NAME = 'StorageMart Facility Amenities';
